import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";

import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import AppLayout from "@/components/AppLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Dashboard from "@/pages/Dashboard";
import Dishes from "@/pages/Dishes";
import Artists from "@/pages/Artists";
import Suppliers from "@/pages/Suppliers";
import Invoices from "@/pages/Invoices";
import Events from "@/pages/Events";
import EventWizard from "@/pages/EventWizard";
import EventDetail from "@/pages/EventDetail";
import Settings from "@/pages/Settings";
import Ingredients from "@/pages/Ingredients";
import Orders from "@/pages/Orders";
import EventsCalendar from "@/pages/EventsCalendar";
import AdminCMS from "@/pages/AdminCMS";
import Plans from "@/pages/Plans";
import RegisterPro, { RegisterProForm } from "@/pages/RegisterPro";

function AppRouter() {
  const location = useLocation();
  // Catch OAuth callback (session_id in hash) synchronously - prevents race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/iscriviti" element={<RegisterPro />} />
      <Route path="/iscriviti/scheda" element={<RegisterProForm />} />
      <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/calendario" element={<EventsCalendar />} />
        <Route path="/eventi" element={<Events />} />
        <Route path="/eventi/nuovo" element={<EventWizard />} />
        <Route path="/eventi/:id" element={<EventDetail />} />
        <Route path="/eventi/:id/modifica" element={<EventWizard />} />
        <Route path="/ordini" element={<Orders />} />
        <Route path="/piatti" element={<Dishes />} />
        <Route path="/ingredienti" element={<Ingredients />} />
        <Route path="/artisti" element={<Artists />} />
        <Route path="/fornitori" element={<Suppliers />} />
        <Route path="/fatture" element={<Invoices />} />
        <Route path="/impostazioni" element={<Settings />} />
        <Route path="/piani" element={<Plans />} />
        <Route path="/admin" element={<AdminCMS />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
